import { ApiClient } from "@/services/ApiService";

export default {
  async deleteUser(id) {
    const response = await ApiClient.delete(`user/${id}`);
    return response.data;
  },
  async getUsers() {
    const response = await ApiClient.get(`user`);
    return response.data;
  },
  async userAccept() {
    const response = await ApiClient.get(`user/accept`);
    return response.data;
  },
  async getUser(id) {
    const response = await ApiClient.get(`user/${id}`);
    return response.data;
  },
  async getCurrentUser() {
    const response = await ApiClient.get(`user/current-user`);
    return response.data;
  },
  async getUserRole() {
    const response = await ApiClient.get(`user/role`);
    return response.data;
  },
  async postUser(user) {
    const response = await ApiClient.post(`user`, user);
    return response.data;
  },
  async postUserSignUp(user) {
    const response = await ApiClient.post(`user/sign-up`, user);
    return response.data;
  },
  async putUser(user) {
    const response = await ApiClient.put(`user/${user.userId}`, user);
    return response.data;
  },
  async sendPasswordReset(credentails) {
    const response = await ApiClient.post(
      "user/send-password-reset",
      credentails
    );
    return response.data;
  },
  async resetPassword(id, credentails) {
    const response = await ApiClient.post(
      `user/reset-password/${id}`,
      credentails
    );
    return response.data;
  }
};
